// El motor de paginación de la cartera: TanStack Table sobre las filas YA filtradas y ordenadas.
//
// El filtro y el orden viven en `logic.ts` y llegan resueltos; acá la tabla solo corta lo cargado en
// páginas, que es lo que leen los controles del pie (ESTANDAR-TABLAS §5.4).
import {
    getCoreRowModel,
    getPaginationRowModel,
    useReactTable,
    type ColumnDef,
    type Table,
} from '@tanstack/react-table';
import { PORTFOLIO_PAGE_SIZE, type PortfolioRow } from '../types';

// Referencia estable: `useReactTable` compara `columns` por referencia igual que `data`. El pintado
// de las columnas vive en `PortfolioTable`, así que el motor no declara ninguna.
const NO_COLUMNS: ColumnDef<PortfolioRow>[] = [];

export function usePortfolioPaginationTable(rows: PortfolioRow[]): Table<PortfolioRow> {
    return useReactTable({
        data: rows,
        columns: NO_COLUMNS,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        initialState: { pagination: { pageSize: PORTFOLIO_PAGE_SIZE } },
    });
}
